"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ucfirst = require("@seafront/ucfirst");

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _TripDetailsWidget = _interopRequireDefault(require("../../03_organisms/TripDetailsWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GenericTripDetailsPageUI = function GenericTripDetailsPageUI(_ref) {
  var sdk = _ref.sdk,
      selectedTrip = _ref.selectedTrip,
      isReturn = _ref.isReturn,
      showSeatsLink = _ref.showSeatsLink,
      confirmLink = _ref.confirmLink,
      numberOfPassengers = _ref.numberOfPassengers,
      isOneWayTrip = _ref.isOneWayTrip,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      history = _ref.history;
  var translatorForNamespace = sdk.i18n.translatorForNamespace;
  var t = translatorForNamespace('GenericTripDetailsPageUI');
  var dep = selectedTrip.originTerminal.name;
  var arr = selectedTrip.destinationTerminal.name;

  var title = function title(a, b) {
    return "".concat((0, _ucfirst.ucfirstEachWord)(a), " \u27F6 ").concat((0, _ucfirst.ucfirstEachWord)(b));
  };

  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('{CityXtoCityY} trip', {
      CityXtoCityY: title(dep, arr)
    }),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_TripDetailsWidget["default"], {
    sdk: sdk,
    trip: selectedTrip,
    isReturn: isReturn,
    numberOfPassengers: numberOfPassengers,
    isOneWayTrip: isOneWayTrip,
    confirmLink: confirmLink,
    showSeatsLink: showSeatsLink,
    onBack: isReturn ? function () {
      return history.push('/book/return');
    } : function () {
      return history.push('/book/out');
    }
  }));
};

var _default = GenericTripDetailsPageUI;
exports["default"] = _default;